import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const FAVICON_ID = 'app-favicon';
const FAVICON_PATH = '/assets/images/taskeo-symbol';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  private readonly platformId = inject(PLATFORM_ID);

  /**
   * Atualiza o favicon conforme o tema.
   * Usa o novo símbolo vetorial com contraste adequado para cada tema.
   */
  setTheme(theme: 'light' | 'dark'): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Adiciona query para forçar refresh quando o tema muda e evitar cache antigo.
    const href = `${window.location.origin}${FAVICON_PATH}-${theme}.svg?v=4`;

    const head = document.head;
    const existing = document.getElementById(FAVICON_ID);

    const link = document.createElement('link');
    link.id = FAVICON_ID;
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    link.href = href;

    if (existing?.parentNode) {
      existing.parentNode.replaceChild(link, existing);
    } else {
      head.appendChild(link);
    }
  }
}
